<div class="exception-body error-page">
  <div class="exception-type">
    <img src="assets/layout/images/error.svg" />
  </div>

  <div class="card exception-panel">
    <i class="material-icons">&#xE000;</i>
    <h1>Exception Occured</h1>
    <div class="exception-detail">Please contact system administrator</div>
    <p-button
      label="Homepage"
      [routerLink]="['/']"
      styleClass="pink-btn"
    ></p-button>
  </div>
</div>
